module.exports = "<default-layout> <page-title [useRoute]=true></page-title> <customer-subscriptions class=flex></customer-subscriptions> </default-layout> ";